<div class="toggle-button" (click)="togglePanel()">
    <div class="toggle-button__icon"
        [class.toggle-button__icon--active]="stateService.isActive"
    ></div>
</div>
